// Manual 3.1 opening ghost placement (frontend AI).
//
// Mirrors AIPlaceGhost for the in-game Haunt action: one placeGhost
// click per invocation. The engine counts placements via
// attacking_ghosts and re-fires this handler (via the next
// OPENING_GHOST_PLACEMENT_ID broadcast) until both ghosts are placed.
//
// Default strategy: split 1+1 across docks 2 and 3 (the outermost).
// Picks the first of those that does not already hold a 1-Ghost card —
// the second invocation naturally lands on the other dock. The
// mid-game ghost-weighting strategy assumes a populated board and is
// the wrong read at setup time.

import { ANGRY_GHOST, SATISFIED_GHOST }
    from '../../TwoD/Common/CardUtilities';

const DEFAULT_OPENING_DOCKS = [2, 3];


function pickDock(gamePlayerData) {
    const docks = (gamePlayerData && gamePlayerData.docks) || [];
    for (const dockIndex of DEFAULT_OPENING_DOCKS) {
        const card = docks[dockIndex];
        if (card !== ANGRY_GHOST && card !== SATISFIED_GHOST) {
            return dockIndex;
        }
    }
    // Both default docks already hold ghosts (rare — second placement
    // landed on the same dock). Stack on the first one.
    return DEFAULT_OPENING_DOCKS[0];
}


export default function artificialOpeningGhostPlacement(
        gamePlayerController, aiPackage) {
    const gamePlayerData = gamePlayerController.gamePlayerData;
    const dockIndex = pickDock(gamePlayerData);
    const question = 'Where should the next opening Ghost go?';
    const answer = `Dock ${dockIndex}`;
    const reason =
        'Setup-time AI: split opening Ghosts across the two outermost '
        + 'Docks (2 and 3). Pick whichever is not already ghosted; the '
        + 'engine drives the second invocation after the first commits.';
    aiPackage.addProvenance(question, answer, reason);
    aiPackage.success = true;
    aiPackage.addToMessage(`Place opening Ghost at Dock ${dockIndex}.`);
    if (aiPackage.execute) {
        gamePlayerController.gamePlayerApi.placeGhost(dockIndex);
    }
}


export const __test__ = {
    DEFAULT_OPENING_DOCKS,
    pickDock,
};
